/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, date: NonNullable<unknown> }} Sub_Overview_Changing_ToInputs */



/**
* | output |
* | --- |
* | "Changing to {plan} on {date}" |
*
* @param {Sub_Overview_Changing_ToInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_changing_to = /** @type {((inputs: Sub_Overview_Changing_ToInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Changing_ToInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wechsel zu ${i?.plan} am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Changing to ${i?.plan} on ${i?.date}`)
});